<div class="location-marker"  [class.draggable]="draggable" #elemRef>
  <svg id="a" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" width="40" height="40" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 40">
    <defs>
      <style>
        .white-fill {
          fill: #fff;
        }

        .clip-path {
          clip-path: url(#b);
        }

        .rect {
          fill: none;
        }

        .orange-fill {
          fill: #ff730a;
        }
      </style>
      <clipPath id="b">
        <rect class="rect" x=".03" y="0" width="40" height="40"/>
      </clipPath>
    </defs>
    <g class="clip-path">
      <g>
        <path class="white-fill" d="M12.25,12.32l-2.63-3.9c3.15-2.12,6.86-3.25,10.66-3.24,3.8,.01,7.5,1.16,10.64,3.3l-2.65,3.89c-1.09-.74-2.28-1.32-3.52-1.74,1.52,.56,2.91,1.4,4.1,2.45,.03,.02,.06,.04,.09,.06l3.35-4.92c-3.14-2.14-6.84-4.04-12.02-4.04s-8.9,1.85-12.05,3.97l3.37,5c1.35-1.21,2.94-2.15,4.71-2.71-1.44,.41-2.81,1.04-4.07,1.88h.02Z"/>
        <path class="orange-fill" d="M30.93,8.48c-3.14-2.14-6.85-3.29-10.64-3.3-3.8,0-7.51,1.12-10.66,3.24l2.63,3.9c1.25-.84,2.63-1.47,4.07-1.88,1.25-.4,2.58-.62,3.96-.62,1.58,0,3.09,.3,4.49,.81,1.24,.41,2.43,.99,3.52,1.74l2.65-3.89h-.02Z"/>
        <path class="white-fill" d="M28.87,13.08c-2.36-1.59-5.77-3.13-8.59-3.14-2.86,0-6.29,1.62-8.66,3.21-2.65,2.38-4.33,5.82-4.33,9.67,0,7.18,5.82,13,13,13s13-5.82,13-13c0-3.88-1.71-7.36-4.41-9.74h0Zm-8.59,21.74c-6.63,0-12-5.37-12-12s5.37-12,12-12,12,5.37,12,12-5.37,12-12,12Z"/>
        <path class="white-fill" d="M20.27,9.94c2.82,0,6.24,1.55,8.59,3.14-1.19-1.05-2.58-1.89-4.1-2.45-1.44-.48-2.95-.74-4.49-.75-1.35,0-2.68,.19-3.96,.55-1.77,.56-3.36,1.5-4.71,2.71,2.37-1.59,5.81-3.22,8.66-3.21h.01Z"/>
        <path class="white-fill" d="M16.31,10.44c1.28-.36,2.61-.56,3.96-.55,1.54,0,3.05,.26,4.49,.75-1.4-.52-2.91-.81-4.49-.81-1.38,0-2.71,.22-3.96,.62h0Z"/>
        <path class="orange-fill" d="M20.28,10.82c-6.63,0-12,5.37-12,12s5.37,12,12,12,12-5.37,12-12-5.37-12-12-12Zm0,20c-4.42,0-8-3.58-8-8s3.58-8,8-8,8,3.58,8,8-3.58,8-8,8Z"/>
        <path class="white-fill" d="M20.28,30.82c4.42,0,8-3.58,8-8s-3.58-8-8-8-8,3.58-8,8,3.58,8,8,8Z"/>
      </g>
    </g>
  </svg>
</div>
